import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider as StyleProvider } from 'styled-components'
import { ThemeProvider } from '@emotion/react'
import { light } from '@leroy-merlin-br/backyard-theme'

import theme from './react-components/theme'
import 'nodelist-foreach-polyfill'

export default (ComponentToRender, selector, parent) => {
  const elementParent = parent || document
  const selectorElements = elementParent.querySelectorAll(selector)

  if (!selectorElements.length) {
    return
  }

  selectorElements.forEach((el) => {
    const dataset = el.dataset

    ReactDOM.render(
      <ThemeProvider theme={light}>
        <StyleProvider theme={theme}>
          <ComponentToRender {...dataset} />
        </StyleProvider>
      </ThemeProvider>,
      el
    )
  })
}
